import type { RowData } from '@tanstack/react-table';

import { ColumnTemplate } from './ColumnTemplate';
import type { DataTableInstance } from './features';

/** A summary row from the columns' `footer` definitions, when any column has one. */
export default function DataTableFooter<T extends RowData>(props: { table: DataTableInstance<T> }) {
    const { table } = props;
    const [footerGroup] = table.getFooterGroups();
    const hasFooter = footerGroup.headers.some(
        (header) => header.column.columnDef.footer !== undefined
    );
    if (!hasFooter) return null;

    return (
        <tfoot>
            <tr>
                {footerGroup.headers.map((header) => {
                    const meta = header.column.columnDef.meta;
                    return (
                        <td
                            key={header.id}
                            data-name={header.column.id}
                            data-align={meta?.align ?? 'left'}
                            className={
                                typeof meta?.cellClassName === 'string'
                                    ? meta.cellClassName
                                    : undefined
                            }>
                            <ColumnTemplate
                                template={header.column.columnDef.footer}
                                context={header.getContext()}
                            />
                        </td>
                    );
                })}
            </tr>
        </tfoot>
    );
}
